/** @jsx jsx */
import { memo } from 'react';
import { jsx } from '@emotion/core';
import { daysGridStyle } from '../styles/grid';
import DateComponent from './date';
var WeekDays = /*#__PURE__*/memo(function WeekDays(_ref) {
  var weeks = _ref.weeks,
      handleClickDay = _ref.handleClickDay,
      mode = _ref.mode,
      testId = _ref.testId;
  return jsx("div", {
    role: "grid",
    "data-testid": testId && "".concat(testId, "--month")
  }, weeks.map(function (week) {
    return jsx("div", {
      role: "row",
      key: week.id,
      css: daysGridStyle
    }, week.values.map(function (_ref2) {
      var id = _ref2.id,
          isDisabled = _ref2.isDisabled,
          isFocused = _ref2.isFocused,
          isToday = _ref2.isToday,
          month = _ref2.month,
          isPreviouslySelected = _ref2.isPreviouslySelected,
          isSelected = _ref2.isSelected,
          isSiblingMonth = _ref2.isSiblingMonth,
          year = _ref2.year,
          day = _ref2.day;
      return jsx(DateComponent, {
        key: id,
        isDisabled: isDisabled,
        isFocused: isFocused,
        isToday: isToday,
        month: month,
        onClick: handleClickDay,
        isPreviouslySelected: isPreviouslySelected,
        isSelected: isSelected,
        isSibling: isSiblingMonth,
        year: year,
        mode: mode,
        testId: testId
      }, day);
    }));
  }));
});
WeekDays.displayName = 'WeekDays';
export default WeekDays;